<div class="app-content content content-dssawere">
    <div class="content-overlay"></div>
    <div class="content-wrapper p-0">
        <div class="content-body">
            <section class="row flexbox-container">
                <div class="col-12 d-flex align-items-center justify-content-center">
                    <div class="col-xxxxl-4 col-xxl-5 col-xl-6 col-md-8 col-10 box-shadow-2 p-0">
                        <div class="card px-1 py-1 m-0">
                            <div class="card-header d-block pb-0">
                                <div class="card-title text-center d-block">
                                    <img src="assets/images/logo/logo-dark.png" alt="branding logo">
                                </div>
                                <h6 class="card-subtitle line-on-side text-center fw-normal pt-2">
                                    <span>{{ 'login.resetpassword.subtitle' | translate }}</span>
                                </h6>
                            </div>
                            <div class="card-content">
                                <app-alert></app-alert>
                                <div class="card-body pb-2">
                                    <form class="form-horizontal" [formGroup]="resetPwdForm" (ngSubmit)="tryReset()">
                                        <fieldset class="form-group input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text input-group-icon"><i class="la la-key"></i></span>
                                            </div>
                                            <input type="password" formControlName="password" class="form-control"
                                                [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
                                                id="user-password" placeholder="{{ 'login.resetpassword.newPasswordPlaceholder' | translate }}" required>
                                            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                                <div *ngIf="f.password.errors.required">{{ 'validations.passwordRequired' | translate }}</div>
                                                <div *ngIf="f.password.errors.minlength">{{ 'validations.passwordMinLength' | translate }}</div>
                                            </div>
                                        </fieldset>
                                        <fieldset class="form-group input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text input-group-icon"><i class="la la-key"></i></span>
                                            </div>
                                            <input type="password" formControlName="confirmPassword" class="form-control"
                                                [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }"
                                                id="confirm-password" placeholder="{{ 'login.resetpassword.confirmPasswordPlaceholder' | translate }}" required>
                                            <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                                                <div *ngIf="f.confirmPassword.errors.required">{{ 'validations.passwordRequired' | translate }}</div>
                                                <div *ngIf="f.confirmPassword.errors.minlength">{{ 'validations.passwordMinLength' | translate }}</div>
                                                <div *ngIf="f.confirmPassword.errors.notSame">{{ 'validations.passwordsDontMatch' | translate }}</div>
                                            </div>
                                        </fieldset>
                                        <fieldset class="form-group">
                                            <button type="submit" class="btn btn-success btn-block" [disabled]="loading">
                                                <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
                                                <i class="feather ft-unlock" *ngIf="!loading"></i> {{ 'login.resetpassword.resetButton' | translate }}
                                            </button>
                                        </fieldset>
                                        <div class="form-group row my-1">
                                            <div class="col-md-6 col-12 text-center text-sm-left pr-0">
                                            
                                            </div>
                                            <div class="col-md-6 col-12 float-sm-left text-center text-sm-right"><a
                                                [routerLink]="['/login']" class="card-link primary fw-bold">{{ 'login.resetpassword.goToLogin' | translate }}</a>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    </div>
</div>